'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

// constants

var _toString = require('./toString');
var _constants = require('./constants');

/*
  This is a heavily modified and reduced version of JSON.prune provided by Canop
  at https://github.com/Canop/JSON.prune. All credit and praise should be directed
  there.
 */

var seen = void 0;

/**
 * iterates on enumerable own properties (default behavior)
 *
 * @param {object} object
 * @param {function} callback
 */
var forEachEnumerableOwnProperty = function forEachEnumerableOwnProperty(object, callback) {
  for (var key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      callback(key);
    }
  }
};

/**
 * return value surrounded by quotes, replacing escapable values
 *
 * @param {string} string
 * @returns {string}
 */
var quote = function quote(string) {
  _constants.ESCAPABLE.lastIndex = 0;
  var c = void 0;
  return !_constants.ESCAPABLE.test(string) ? '"' + string + '"' : '"' + string.replace(_constants.ESCAPABLE, function (a) {
    c = _constants.META[a];
    return (0, _toString.toString)(c) === _toString.STRING ? c : "\\u" + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
  }) + '"';
};

/**
 * prune JSON for stringification
 *
 * @param {*} value
 * @returns {string}
 */
var prune = function prune(value) {
  seen = [];
  var pruneString = function pruneString(key, holder, depthDecr) {
    var value = holder[key],
      type = typeof value === 'undefined' ? 'undefined' : _typeof(value),
      partial = [],
      v = void 0;
    if (type === _constants.STRING_TYPEOF) {
      return quote(value);
    }
    if (type === _constants.BOOLEAN_TYPEOF || type === _constants.NUMBER_TYPEOF || type === _constants.UNDEFINED_TYPEOF) {
      return '' + value;
    }
    if (type === _constants.FUNCTION_TYPEOF) {
      return (0, _toString.toFunctionString)(value);
    }
    if (!value) {
      return '' + value;
    }
    var index = seen.indexOf(value);
    if (depthDecr <= 0 || !!~index) {
      return _constants.DEFAULT_PRUNED_VALUE + '-' + index;
    }
    type = (0, _toString.toString)(value);
    if (type === _toString.ARRAY) {
      seen.push(value);
      var length = Math.min(value.length, _constants.DEFAULT_ARRAY_MAX_LENGTH);
      var _index = -1;
      while (++_index < length) {
        partial[_index] = pruneString(_index, value, depthDecr - 1);
      }
      v = '[' + partial.join(',') + ']';
      return v;
    }
    if (type === _toString.DATE) {
      return '' + value.valueOf();
    }
    seen.push(value);
    forEachEnumerableOwnProperty(value, function (k) {
      try {
        v = pruneString(k, value, depthDecr - 1);
        if (v) {
          partial.push(quote(k) + ':' + v);
        }
      } catch (exception) {
        // this try/catch due to forbidden accessors on some objects
      }
    });
    return '{' + partial.join(',') + '}';
  };
  return pruneString('', {
    '': value
  }, _constants.DEFAULT_MAX_DEPTH);
};
exports.default = {
  prune: prune
};
module.exports = exports['default'];